export default "__VITE_ASSET__CcfgmjAo__"